import React, { useEffect } from 'react'
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { cilAccountLogout } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useSelector, useDispatch } from 'react-redux'
import { api, currentUser, logout } from '../../api/client'

// [RGM] 2026-10-07 (pedido Rafael: "pone el rol real Administrador, no el
// companyadmin en inglés"): el /auth/me devuelve el código web del rol
// (AuthController.RolWeb: companyadmin/collector/supervisor/...); aquí se
// muestra el nombre real en español.
const ROL_WEB_TEXTO = {
  companyadmin: 'Administrador',
  superadmin: 'SuperAdmin',
  collector: 'Cobrador',
  supervisor: 'Supervisor',
  cliente: 'Cliente',
  aliado: 'Aliado',
}

/**
 * Dropdown del usuario autenticado: identidad + cierre de sesión.
 * Reemplaza el dropdown demo del template CoreUI (Updates 42, Messages 42...).
 * El avatar muestra el logo de la empresa (store Redux, EmpresaLogo_GXI)
 * dentro del circulo; si no hay logo, la inicial del usuario.
 */
const AppHeaderDropdown = () => {
  const user = currentUser()
  const dispatch = useDispatch()
  const empresaLogo = useSelector((s) => s.empresaLogo)
  const empresaNombre = useSelector((s) => s.empresaNombre)

  // Si el store aún no tiene la empresa, la carga una sola vez (por companyId)
  // para que el Navbar muestre el logo aunque el usuario nunca abra Mi Cuenta.
  // Silencioso: ante error se muestra la inicial.
  useEffect(() => {
    if (!user?.companyId || empresaNombre) return
    api.get(`/cuenta?empresa=${encodeURIComponent(user.companyId)}`)
      .then((res) =>
        dispatch({ type: 'set', empresaLogo: res.logoUrl ?? null, empresaNombre: res.nombre }),
      )
      .catch(() => {})
  }, [user?.companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0 pe-0" caret={false}>
        <CAvatar color="primary" size="md" src={empresaLogo || undefined}>
          {(empresaNombre || user?.id || '?').slice(0, 1).toUpperCase()}
        </CAvatar>
      </CDropdownToggle>
      <CDropdownMenu
        className="pt-0"
        placement="bottom-end"
        style={{ overflow: 'hidden' }}
      >
        {/* [RGM] 2026-10-06/07 (pedido Rafael): línea 1 = NOMBRE DE LA EMPRESA
            (antes usuario · rol); línea 2 = el ROL real en español
            (Administrador/Cobrador...). Ambos CENTRADOS y SIN el margen
            inferior (mb-2) que dejaba un espacio blanco debajo — igual que
            quedó el título de Notificaciones. */}
        <CDropdownHeader className="bg-body-secondary fw-semibold text-center">
          <div>{empresaNombre || user?.id || 'Usuario'}</div>
          {user?.role && (
            <div className="small fw-normal text-body-secondary">
              {ROL_WEB_TEXTO[user.role] ?? user.role}
            </div>
          )}
        </CDropdownHeader>
        {/* [RGM] 2026-10-07 (pedido Rafael: "sigo viendo un espacio entre lo
            gris y la línea"): fuera el divisor — su margen dejaba el hueco
            entre la franja gris y la línea; el menú queda como el de
            Notificaciones. */}
        <CDropdownItem onClick={logout}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          Salir
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
